import Feature12_2 from './Feature12_2'
export default Feature12_2
